import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NaviService } from '../../services/navi.service';
import { RegisterService } from '../../services/register.service';

import { BasicError } from '../../models/error/error';


@Component({
  selector: 'app-verification-completed',
  templateUrl: './verification-completed.component.html',
  styleUrls: ['./verification-completed.component.css']
})
export class VerificationCompletedComponent implements OnInit {
  private loginUrl: String = 'login';

  public token: String = '';

  public verifiedSuccessfully: Boolean = false;
  public resendVeri: Boolean = false;

  public inpEmail: String;
  public outputInfo: String;
  public alertInfo: Boolean = false;

  constructor(private naviService: NaviService, private route: ActivatedRoute, private registerService: RegisterService) { }

  ngOnInit() {
    this.token = this.route.snapshot.queryParams['token'];

    this.registerService.verifyToken(this.token).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('----- Failed to verify token -----');
        this.verifiedSuccessfully = false;
      } else {
        this.verifiedSuccessfully = true;
      }
    });
  }

  public requestResendVerification() {
    this.resendVeri = true;
    this.alertInfo = false;
  }

  public resendNewVerification() {
    this.registerService.resendVerification(this.inpEmail).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('------ Failed to resend Verification ------');
        this.resendVeri = true;
        this.outputInfo = 'Anforderung der Email ist fehlgeschlagen!';
        this.alertInfo = true;
      } else {
        this.resendVeri = false;
        this.outputInfo = 'Die Email wurde erfolgreich versendet.';
        this.alertInfo = true;
      }
    });
  }


  public navigateToLogin() {
    this.naviService.navigateToUrl(this.loginUrl, 'login');
  }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/verification-completed/verification-completed.component.ts